var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8bc5ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 100c-27.57 0-50-22.43-50-50s22.43-50 50-50 50 22.43 50 50-22.43 50-50 50zm0-92.855c-23.645 0-42.855 19.211-42.855 42.855s19.215 42.855 42.855 42.855c23.645 0 42.855-19.215 42.855-42.855 0-23.645-19.211-42.855-42.855-42.855z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.145 42.855c-2 0-3.5703-1.5703-3.5703-3.5703v-10.715c0-2 1.5703-3.5703 3.5703-3.5703s3.5703 1.5703 3.5703 3.5703v10.715c0 2-1.5703 3.5703-3.5703 3.5703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.855 42.855c-2 0-3.5703-1.5703-3.5703-3.5703v-10.715c0-2 1.5703-3.5703 3.5703-3.5703s3.5703 1.5703 3.5703 3.5703v10.715c0 2-1.5703 3.5703-3.5703 3.5703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 78.57c-10.855 0-19.645-8.7852-19.645-19.645 0-2 1.5703-3.5703 3.5703-3.5703s3.5703 1.5703 3.5703 3.5703c0 6.8555 5.6445 12.5 12.5 12.5 6.8555 0 12.5-5.6445 12.5-12.5 0-2 1.5703-3.5703 3.5703-3.5703s3.5703 1.5703 3.5703 3.5703c0 10.855-8.7852 19.645-19.645 19.645z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLarge);
export default __webpack_public_path__ + "static/media/client-large.3b18de47bc9c2546439bb2571cb20c97.svg";
export { ForwardRef as ReactComponent };